// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"bi-z"};